export enum AppGtmEvent {
	START_QUOTE = 'startQuote',
	CALL_ME_BACK = 'callback'
}
